import React from 'react';

import styled from 'styled-components';

const NewSidepanelHeader = ({ leftAction, rightAction, withBottomBorder = true }) => (
  <Container withBottomBorder={withBottomBorder}>
    {leftAction || null}
    {rightAction || null}
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  border-bottom: ${(props) => (props.withBottomBorder ? `1px solid ${props.theme.palette.borders.lighterGrey}` : '0')};
`;

export default NewSidepanelHeader;
